export const getSelectionMetadata = (selection: any) => {
	if (selection._objects) {
		return {
			isGroup: selection.type === "group",
			isMultiple: true,
		};
	} else {
		return {
			isGroup: false,
			isMultiple: false,
		};
	}
};
export const getTextOptions = (selection: any) => {
	const selectionMetadata = getSelectionMetadata(selection);
	if (selection._objects) {
		const object = selection._objects[0];
		const {
			underline,
			linethrough,
			textBackgroundColor,
			backgroundColor,
			textAlign,
			fontSize,
			fill,
			charSpacing,
			fontWeight,
			lineHeight,
			fontFamily,
			fontURL,
			textType,
			customFontName,
			fontStyle,
			colorNumber,
			shadowColorNumber,
			brandId,
			fontType,
			fixedSize,
			fixedWidthValue,
			maximumFontSize,
			fixedHeightValue,
		} = object;
		return {
			underline,
			linethrough,
			textBackgroundColor,
			backgroundColor,
			textAlign,
			fontSize,
			fill,
			charSpacing,
			fontWeight,
			lineHeight,
			fontFamily,
			fontURL,
			textType,
			customFontName,
			fontStyle,
			colorNumber,
			shadowColorNumber,
			brandId,
			fontType,
			fixedSize,
			fixedWidthValue,
			maximumFontSize,
			fixedHeightValue,
			...selectionMetadata,
		};
	} else {
		const {
			underline,
			linethrough,
			textBackgroundColor,
			backgroundColor,
			textAlign,
			fontSize,
			fill,
			charSpacing,
			fontWeight,
			lineHeight,
			fontFamily,
			fontURL,
			textType,
			customFontName,
			fontStyle,
			colorNumber,
			shadowColorNumber,
			brandId,
			fontType,
			fixedSize,
			fixedWidthValue,
			maximumFontSize,
			fixedHeightValue,
		} = selection;
		return {
			underline,
			linethrough,
			textBackgroundColor,
			backgroundColor,
			textAlign,
			fontSize,
			fill,
			charSpacing,
			fontWeight,
			lineHeight,
			fontFamily,
			fontURL,
			textType,
			customFontName,
			fontStyle,
			colorNumber,
			shadowColorNumber,
			brandId,
			fontType,
			fixedSize,
			fixedWidthValue,
			maximumFontSize,
			fixedHeightValue,
			...selectionMetadata,
		};
	}
};
